module.exports = __webpack_public_path__ + "img/wondergreek_tech_Normal_ua.8daa27d0.webp";